import { useState, useEffect } from 'react'
import axios from 'axios'
import config from './../../config';

export default function useHeaderData() {
  const [menuStory, setMenuStory] = useState([])
  const [headerData, setHeaderData] = useState([])

  const getAllMenu = async () => {
    try {
      const response = await axios.get(`${config.REACT_APP_API_URL}/categories_actif`,{
            headers: { 
            'x-api-key': config.SITE_API_KEY
           }})
      setMenuStory(response?.data?.result || [])
    } catch (error) {
      console.error('Error fetching menu story:', error)
      setMenuStory([])
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([getAllMenu()])
    }
    fetchData()
  }, [])

  useEffect(() => {
    setHeaderData([
      {
        title: 'Accueil',
        link: '/'
    },
    {
        title: 'A Propos',
        link: 'apropos'
    },
      {
        title: "Categories des Produits",
        link:'product'
      },
      {
          title: 'Contact',
          link:'contact'
      },
    ])
  }, [menuStory])

  return headerData
}